export default __webpack_public_path__ + "static/media/SWE.1013cca8.svg";